// extracted by mini-css-extract-plugin
module.exports = {"nav-desktop":"NavDesktop_nav-desktop__PR9Ct"};